import { render, staticRenderFns } from "./SingleProductionOrder.vue?vue&type=template&id=251a98c5&scoped=true"
import script from "./SingleProductionOrder.vue?vue&type=script&lang=js"
export * from "./SingleProductionOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleProductionOrder.vue?vue&type=style&index=0&id=251a98c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a98c5",
  null
  
)

export default component.exports